import request from '@/util/http'
import qs from "qs";
export function questionGroupList(query) {
    return request({
        url: '/admin/tHallInellijQuestionGroup/list',
        method: 'get',
        params: query
    })
}
export function questionViews(query) {
    return request({
        url: '/admin/tHallInellijQuestion/views',
        method: 'get',
        params: query
    })
}
export function questionList(query) {
    return request({
        url: '/admin/tHallInellijQuestion/list',
        method: 'get',
        params: query
    })
}
export function questionHotList(obj) {
    return request({
        url: '/admin/tHallInellijQuestion/hotList',
        method: 'post',
        data: qs.stringify(obj)
    })
}
export function questionGroupSave(obj) {
    return request({
        url: '/admin/tHallInellijQuestionGroup/save',
        method: 'post',
        data: obj
    })
}
export function questionGroupDelete(obj) {
    return request({
        url: '/admin/tHallInellijQuestionGroup/delete',
        method: 'post',
        params: obj
    })
}
export function questionSave(obj) {
    return request({
        url: '/admin/tHallInellijQuestion/save',
        method: 'post',
        data: obj
    })
}
export function questionDelete(obj) {
    return request({
        url: '/admin/tHallInellijQuestion/delete',
        method: 'post',
        params: obj
    })
}
export function questionUpdate(obj) {
    return request({
        url: '/admin/tHallInellijQuestion/update',
        method: 'post',
        data: obj
    })
}
export function questionQueryCntVoList(obj) {
    return request({
        url: '/admin/tHallInellijQuestion/queryCntVoList',
        method: 'post',
        data: obj
    })
}
export function upVote(params) {
    return request({
        url: '/admin/tHallInellijQuestion/upVote',
        method: 'get',
        params: params
    })
}
export function downVote(params) {
    return request({
        url: '/admin/tHallInellijQuestion/downVote',
        method: 'get',
        params: params
    })
}
